import { IconButton, SecondaryButton } from '@chegg-ui/button'
import { colors, font, spacing } from '@chegg-ui/theme'
import { Typography } from '@chegg-ui/typography'
import styled from 'styled-components'
import { ShimmerBodyText } from '@chegg-ui/shimmer'

export const BubbleOptionsContainer = styled.div<{ suggestionsOpen: boolean }>`
  display: flex;
  flex-direction: column;
  gap: ${spacing.px8};
  color: ${colors.grey900};
  background: ${colors.white};
  box-shadow: 0px 4.163px 50.163px 0px rgba(41, 21, 67, 0.16);
  font-size: ${spacing.px16};

  border: 0.52px solid ${colors.white};
  border-radius: ${({ suggestionsOpen }) =>
    suggestionsOpen ? `${spacing.px16}` : `${spacing.px48}`};
  padding: ${({ suggestionsOpen }) =>
    suggestionsOpen ? `${spacing.px8} ${spacing.px12} 0;` : `${spacing.px4}`};
`

export const QuickActionButton = styled(IconButton).attrs({
  variant: 'simple',
  size: 'xsmall',
})`
  & {
    border-radius: 30px;
    background-color: ${colors.orange050};
    font-size: ${font.size.px12};
    font-weight: ${font.weight.bold};
    padding: ${spacing.px4} ${spacing.px12};
    column-gap: ${spacing.px4};
  }

  &:hover {
    background-color: ${colors.orange200};
    transform: unset;
  }

  &:disabled {
    background-color: ${colors.grey300};
  }
`
export const StyledIconButton = styled(IconButton).attrs({
  variant: 'simple',
  size: 'xsmall',
})`
  & {
    background-color: ${colors.transparent};
    color: #2b196f;
  }

  &[aria-selected='true'] {
    background-color: ${colors.violet300};
  }

  &:hover {
    background-color: ${colors.violet300};
  }

  svg {
    padding: ${spacing.px8} ${spacing.px16};
    height: ${spacing.px40};
    width: 3.5rem;
  }
`

export const BubbleOptionsButtonLeft = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-evenly;
`

export const BubbleMenuHeader = styled.div`
  display: flex;
  border-radius: ${spacing.px48};
  background-color: ${colors.orange050};
  padding: 2px;
`

export const BubbleMenuSuggestionsContainer = styled.div`
  max-width: 300px;
`

export const SuggestionsTitleWithIcon = styled(Typography).attrs({
  variant: 'body2',
})`
  display: flex;
  align-items: center;
  column-gap: ${spacing.px8};
  font-weight: ${font.weight.normal};

  > svg {
    flex-shrink: 0;
  }
`

export const SuggestionsHeader = styled.div``

export const SynonymsContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: ${spacing.px8};
  margin: ${spacing.px8} 0;

  max-height: 150px;
  overflow: auto;
  ::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
`

export const SynonymSuggestionBtn = styled(SecondaryButton).attrs({
  variant: 'outlined',
  size: 'xsmall',
})`
  padding: ${spacing.px4} ${spacing.px8};
`
export const ShimmerSynonyms = styled(ShimmerBodyText)`
  width: 80px;
  height: 25px;
  border-radius: 60px;

  & + & {
    margin-top: 0;
  }
`
